// Internationalization (i18n) translations
export const translations = {
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      accounts: "Accounts",
      posts: "Posts Analytics",
      comments: "Comments",
      insights: "AI Insights",
      settings: "Settings",
    },
    // Header
    header: {
      title: "A2O SNS Analytics",
      subtitle: "Performance Tracker",
      posts: "posts",
      accounts: "accounts",
      dashboardOverview: "Dashboard Overview",
      accountsAnalysis: "Accounts Analysis",
      postsAnalysis: "Posts Analytics",
      commentsAnalysis: "Comments Analysis",
      aiInsights: "AI Insights",
      settings: "Settings",
      selectPlatform: "Select Platform",
      selectAccount: "Select Account",
      allPlatforms: "All Platforms",
      allAccounts: "All Accounts",
      platformsSelected: "platforms selected",
      accountsSelected: "accounts selected",
      clearAll: "Clear Selection",
      refresh: "Refresh",
      lastUpdated: "Last updated",
    },
    // Metrics
    metrics: {
      totalViews: "Total Views",
      totalLikes: "Total Likes",
      comments: "Comments",
      shares: "Shares",
      saves: "Saves",
      avgEngagement: "Avg Engagement",
      followers: "Followers",
      posts: "Posts",
      vsLastWeek: "vs last week",
      vsPrevPeriod: "vs prev. period",
      vsPrevPeriodDays: "vs prev. {days} days",
      noComparison: "No comparison data",
    },
    // Date Filter
    dateFilter: {
      noDataTitle: "No Data for Selected Period",
      noDataDescription: "There are no posts within the selected date range. Try extending the date range or clearing the filter.",
      clearFilter: "Clear Date Filter",
      extendRange: "Last 30 Days",
    },
    // Charts
    charts: {
      engagementTrends: "Engagement Trends",
      platformDistribution: "Platform Distribution",
      accountComparison: "Account Performance Comparison",
    },
    // Posts
    posts: {
      topPerforming: "Top Performing Posts",
      needsAttention: "Needs Attention",
      allPosts: "All Posts Performance",
      postList: "Post List",
      views: "views",
      engagement: "eng.",
      post: "Post",
      platform: "Platform",
      velocity: "Velocity",
      openOriginal: "Open original post",
      viewsHeader: "Views",
      likesHeader: "Likes",
      commentsHeader: "Comments",
      engagementHeader: "Engagement",
      linkHeader: "Link",
    },
    // Accounts
    accounts: {
      title: "Accounts Analysis",
      totalViews: "Total Views",
      avgEngagement: "Avg Engagement",
      back: "Back",
    },
    // AI Insights
    insights: {
      title: "AI Insights",
      generate: "Generate",
      analyzing: "Analyzing...",
      clickGenerate: 'Click "Generate" to get AI-powered insights',
      recommendations: "Recommendations",
      anomalies: "Anomalies Detected",
      generatedAt: "Generated at",
    },
    // Settings
    settings: {
      apiCredentials: "API Credentials",
      youtubeSync: "YouTube Sync",
      emailAlerts: "Email Alerts",
      platformCredentials: "Platform API Credentials",
      credentialsDesc: "Configure API credentials for each social media platform",
      addCredentials: "Add Credentials",
      noCredentials: "No credentials configured yet",
      youtubeStatus: "YouTube API Status",
      youtubeConfigured: "YouTube API configured",
      youtubeNotConfigured: "YouTube API not configured",
      syncChannel: "Sync Channel",
      refreshAll: "Refresh All",
      syncYoutubeChannel: "Sync YouTube Channel",
      syncDesc: "Import videos and metrics from a YouTube channel",
      channelHandle: "Channel Handle or URL",
      channelPlaceholder: "e.g., @A2O_Channel or https://youtube.com/@A2O_Channel",
      syncing: "Syncing...",
      emailStatus: "Email Service Status",
      emailConfigured: "Email service configured",
      emailNotConfigured: "Email service not configured",
      alertRules: "Alert Rules",
      alertsDesc: "Get notified when metrics drop below or exceed thresholds",
      createAlert: "Create Alert",
      noAlerts: "No alert rules configured",
      alertName: "Alert Name",
      email: "Email",
      metric: "Metric",
      condition: "Condition",
      threshold: "Threshold",
      below: "Below",
      above: "Above",
      lastTriggered: "Last triggered",
      recentAlertHistory: "Recent Alert History",
      sent: "Sent",
      notSent: "Not sent",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
    },
    // Export
    export: {
      csv: "CSV",
      report: "Report",
    },
    // Language Analysis
    languageAnalysis: {
      title: "Comment Language Analysis",
      analyzeBtn: "Analyze Languages",
      analyzing: "Analyzing...",
      totalComments: "Total Comments Analyzed",
      language: "Language",
      count: "Count",
      percentage: "Percentage",
      sampleComments: "Sample Comments",
      noData: "No language analysis available. Click analyze to start.",
      lastAnalyzed: "Last analyzed",
      commentsDisabled: "Comments are disabled for this video",
    },
    // Comments Section
    comments: {
      title: "Comments Analysis",
      summary: "Summary",
      postsAnalyzed: "Posts Analyzed",
      totalComments: "Total Comments",
      languageDistribution: "Language Distribution",
      sentimentAnalysis: "Sentiment Analysis",
      keywordsTopics: "Keywords & Topics",
      postsList: "Posts Analysis List",
      batchAnalyze: "Batch Analyze",
      analyzeAll: "Analyze All",
      analyzing: "Analyzing...",
      positive: "Positive",
      negative: "Negative",
      neutral: "Neutral",
      sentiment: "Sentiment",
      keyword: "Keyword",
      noAnalysis: "No comments analysis yet. Select posts to analyze.",
      selectPosts: "Select posts to analyze",
      filterByLanguage: "Filter by Language",
      filterBySentiment: "Filter by Sentiment",
      allLanguages: "All Languages",
      allSentiments: "All Sentiments",
      viewDetails: "View Details",
      overallSentiment: "Overall Sentiment",
      topKeywords: "Top Keywords",
      analysisHistory: "Analysis History",
      deleteAll: "Delete All",
      deleteAnalysis: "Delete",
      confirmDeleteAll: "Delete all past analysis results?",
      confirmDelete: "Delete this analysis result?",
      historyCount: "results",
      noHistory: "No past analysis results",
      loadHistory: "View Past Results",
    },
    // Common
    common: {
      language: "Language",
      english: "English",
      korean: "한국어",
      chinese: "中文",
    },
    // Content Growth
    contentGrowth: {
      title: "Content Growth",
      subtitle: "Track performance changes over time",
      selectPeriod: "Select Period",
      startDate: "Start Date",
      endDate: "End Date",
      analyze: "Analyze Growth",
      analyzing: "Analyzing...",
      noData: "No growth data available yet. Daily metrics are collected at CST 00:00.",
      noDataDescription: "Data collection starts from today. Please wait until at least 2 days of data is collected.",
      goodPerformers: "Good Performers",
      poorPerformers: "Poor Performers",
      growthRate: "Growth Rate",
      viewsDelta: "Views Change",
      likesDelta: "Likes Change",
      commentsDelta: "Comments Change",
      sharesDelta: "Shares Change",
      periodStart: "Period Start",
      periodEnd: "Period End",
      delta: "Change",
      allContent: "All Content",
      sortBy: "Sort by",
      totalGrowth: "Total Growth",
      avgGrowthRate: "Avg Growth Rate",
      postsAnalyzed: "Posts Analyzed",
      manualSnapshot: "Save Snapshot Now",
      snapshotSaved: "Snapshot saved successfully",
      scheduleInfo: "Data is automatically collected daily at 00:00 CST",
    },
  },
  ko: {
    nav: {
      dashboard: "대시보드",
      accounts: "계정별 분석",
      posts: "게시물 분석",
      comments: "댓글 분석",
      insights: "AI 인사이트",
      settings: "설정",
    },
    header: {
      title: "A2O SNS Analytics",
      subtitle: "성과 추적기",
      posts: "개 게시물",
      accounts: "개 계정",
      dashboardOverview: "대시보드 개요",
      accountsAnalysis: "계정별 분석",
      postsAnalysis: "게시물 분석",
      commentsAnalysis: "댓글 분석",
      aiInsights: "AI 인사이트",
      settings: "설정",
      selectPlatform: "플랫폼 선택",
      selectAccount: "계정 선택",
      allPlatforms: "전체 플랫폼",
      allAccounts: "전체 계정",
      platformsSelected: "개 플랫폼 선택됨",
      accountsSelected: "개 계정 선택됨",
      clearAll: "선택 해제",
      refresh: "새로고침",
      lastUpdated: "마지막 업데이트",
    },
    metrics: {
      totalViews: "총 조회수",
      totalLikes: "총 좋아요",
      comments: "댓글",
      shares: "공유",
      saves: "저장",
      avgEngagement: "평균 참여율",
      followers: "팔로워",
      posts: "게시물",
      vsLastWeek: "지난주 대비",
      vsPrevPeriod: "이전 동일 기간 대비",
      vsPrevPeriodDays: "이전 {days}일 대비",
      noComparison: "비교 데이터 없음",
    },
    dateFilter: {
      noDataTitle: "선택 기간에 데이터 없음",
      noDataDescription: "선택한 날짜 범위에 게시물이 없습니다. 날짜 범위를 확장하거나 필터를 해제해 보세요.",
      clearFilter: "날짜 필터 해제",
      extendRange: "최근 30일",
    },
    charts: {
      engagementTrends: "참여 트렌드",
      platformDistribution: "플랫폼별 분포",
      accountComparison: "플랫폼별 계정 성과 비교",
    },
    posts: {
      topPerforming: "인기 게시물",
      needsAttention: "개선 필요 게시물",
      allPosts: "전체 게시물 성과",
      postList: "게시물 목록",
      views: "조회",
      engagement: "참여",
      post: "게시물",
      platform: "플랫폼",
      velocity: "성장률",
      openOriginal: "원본 게시물 열기",
      viewsHeader: "조회수",
      likesHeader: "좋아요",
      commentsHeader: "댓글",
      engagementHeader: "참여율",
      linkHeader: "링크",
    },
    accounts: {
      title: "계정별 분석",
      totalViews: "총 조회수",
      avgEngagement: "평균 참여율",
      back: "뒤로",
    },
    insights: {
      title: "AI 인사이트",
      generate: "생성",
      analyzing: "분석 중...",
      clickGenerate: '"생성" 버튼을 클릭하여 AI 인사이트를 받아보세요',
      recommendations: "추천사항",
      anomalies: "이상 징후 감지",
      generatedAt: "생성 시간",
    },
    settings: {
      apiCredentials: "API 인증정보",
      youtubeSync: "YouTube 동기화",
      emailAlerts: "이메일 알림",
      platformCredentials: "플랫폼 API 인증정보",
      credentialsDesc: "각 소셜 미디어 플랫폼의 API 인증정보를 설정하세요",
      addCredentials: "인증정보 추가",
      noCredentials: "설정된 인증정보가 없습니다",
      youtubeStatus: "YouTube API 상태",
      youtubeConfigured: "YouTube API 설정됨",
      youtubeNotConfigured: "YouTube API 미설정",
      syncChannel: "채널 동기화",
      refreshAll: "전체 새로고침",
      syncYoutubeChannel: "YouTube 채널 동기화",
      syncDesc: "YouTube 채널에서 동영상과 지표를 가져옵니다",
      channelHandle: "채널 핸들 또는 URL",
      channelPlaceholder: "예: @A2O_Channel 또는 https://youtube.com/@A2O_Channel",
      syncing: "동기화 중...",
      emailStatus: "이메일 서비스 상태",
      emailConfigured: "이메일 서비스 설정됨",
      emailNotConfigured: "이메일 서비스 미설정",
      alertRules: "알림 규칙",
      alertsDesc: "지표가 임계값 아래로 떨어지거나 초과할 때 알림을 받습니다",
      createAlert: "알림 생성",
      noAlerts: "설정된 알림 규칙이 없습니다",
      alertName: "알림 이름",
      email: "이메일",
      metric: "지표",
      condition: "조건",
      threshold: "임계값",
      below: "미만",
      above: "초과",
      lastTriggered: "마지막 발생",
      recentAlertHistory: "최근 알림 기록",
      sent: "전송됨",
      notSent: "미전송",
      cancel: "취소",
      save: "저장",
      delete: "삭제",
    },
    export: {
      csv: "CSV",
      report: "리포트",
    },
    languageAnalysis: {
      title: "댓글 언어 분석",
      analyzeBtn: "언어 분석",
      analyzing: "분석 중...",
      totalComments: "분석된 총 댓글 수",
      language: "언어",
      count: "개수",
      percentage: "비율",
      sampleComments: "샘플 댓글",
      noData: "언어 분석 데이터가 없습니다. 분석 버튼을 클릭하세요.",
      lastAnalyzed: "마지막 분석",
      commentsDisabled: "이 동영상은 댓글이 비활성화되어 있습니다",
    },
    comments: {
      title: "댓글 분석",
      summary: "요약",
      postsAnalyzed: "분석된 게시물",
      totalComments: "총 댓글 수",
      languageDistribution: "언어 분포",
      sentimentAnalysis: "감정 분석",
      keywordsTopics: "키워드 & 토픽",
      postsList: "게시물별 분석",
      batchAnalyze: "일괄 분석",
      analyzeAll: "전체 분석",
      analyzing: "분석 중...",
      positive: "긍정",
      negative: "부정",
      neutral: "중립",
      sentiment: "감정",
      keyword: "키워드",
      noAnalysis: "아직 분석된 댓글이 없습니다. 게시물을 선택하여 분석하세요.",
      selectPosts: "분석할 게시물 선택",
      filterByLanguage: "언어별 필터",
      filterBySentiment: "감정별 필터",
      allLanguages: "전체 언어",
      allSentiments: "전체 감정",
      viewDetails: "상세 보기",
      overallSentiment: "전체 감정",
      topKeywords: "인기 키워드",
      analysisHistory: "분석 이력",
      deleteAll: "전체 삭제",
      deleteAnalysis: "삭제",
      confirmDeleteAll: "모든 과거 분석 결과를 삭제하시겠습니까?",
      confirmDelete: "이 분석 결과를 삭제하시겠습니까?",
      historyCount: "건",
      noHistory: "과거 분석 결과가 없습니다",
      loadHistory: "과거 결과 보기",
    },
    common: {
      language: "언어",
      english: "English",
      korean: "한국어",
      chinese: "中文",
    },
    // Content Growth
    contentGrowth: {
      title: "콘텐츠 성장 분석",
      subtitle: "시간에 따른 콘텐츠 퍼포먼스 변화 추적",
      selectPeriod: "기간 선택",
      startDate: "시작일",
      endDate: "종료일",
      analyze: "성장 분석",
      analyzing: "분석 중...",
      noData: "아직 성장 데이터가 없습니다. 일별 메트릭은 매일 중국 시간 00:00에 수집됩니다.",
      noDataDescription: "오늘부터 데이터 수집이 시작됩니다. 최소 2일 이상의 데이터가 수집될 때까지 기다려주세요.",
      goodPerformers: "성장 우수 콘텐츠",
      poorPerformers: "성장 부진 콘텐츠",
      growthRate: "성장률",
      viewsDelta: "조회수 변화",
      likesDelta: "좋아요 변화",
      commentsDelta: "댓글 변화",
      sharesDelta: "공유 변화",
      periodStart: "기간 시작",
      periodEnd: "기간 종료",
      delta: "변화량",
      allContent: "전체 콘텐츠",
      sortBy: "정렬 기준",
      totalGrowth: "총 성장",
      avgGrowthRate: "평균 성장률",
      postsAnalyzed: "분석된 게시물",
      manualSnapshot: "지금 스냅샷 저장",
      snapshotSaved: "스냅샷이 저장되었습니다",
      scheduleInfo: "데이터는 매일 중국 시간 00:00에 자동으로 수집됩니다",
    },
  },
  zh: {
    nav: {
      dashboard: "仪表板",
      accounts: "账户分析",
      posts: "帖子分析",
      comments: "评论分析",
      insights: "AI洞察",
      settings: "设置",
    },
    header: {
      title: "A2O SNS Analytics",
      subtitle: "业绩追踪器",
      posts: "个帖子",
      accounts: "个账户",
      dashboardOverview: "仪表板概览",
      accountsAnalysis: "账户分析",
      postsAnalysis: "帖子分析",
      commentsAnalysis: "评论分析",
      aiInsights: "AI洞察",
      settings: "设置",
      selectPlatform: "选择平台",
      selectAccount: "选择账户",
      allPlatforms: "全部平台",
      allAccounts: "全部账户",
      platformsSelected: "个平台已选",
      accountsSelected: "个账户已选",
      clearAll: "清除选择",
      refresh: "刷新",
      lastUpdated: "最后更新",
    },
    metrics: {
      totalViews: "总浏览量",
      totalLikes: "总点赞",
      comments: "评论",
      shares: "分享",
      saves: "收藏",
      avgEngagement: "平均互动率",
      followers: "粉丝",
      posts: "帖子",
      vsLastWeek: "较上周",
      vsPrevPeriod: "较前同期",
      vsPrevPeriodDays: "较前{days}天",
      noComparison: "无比较数据",
    },
    charts: {
      engagementTrends: "互动趋势",
      platformDistribution: "平台分布",
      accountComparison: "各平台账户业绩对比",
    },
    posts: {
      topPerforming: "热门帖子",
      needsAttention: "需要关注",
      allPosts: "全部帖子业绩",
      postList: "帖子列表",
      views: "浏览",
      engagement: "互动",
      post: "帖子",
      platform: "平台",
      velocity: "增长率",
      openOriginal: "打开原始帖子",
      viewsHeader: "浏览量",
      likesHeader: "点赞",
      commentsHeader: "评论",
      engagementHeader: "互动率",
      linkHeader: "链接",
    },
    accounts: {
      title: "账户分析",
      totalViews: "总浏览量",
      avgEngagement: "平均互动率",
      back: "返回",
    },
    insights: {
      title: "AI洞察",
      generate: "生成",
      analyzing: "分析中...",
      clickGenerate: '点击"生成"获取AI分析洞察',
      recommendations: "建议",
      anomalies: "检测到异常",
      generatedAt: "生成时间",
    },
    settings: {
      apiCredentials: "API凭证",
      youtubeSync: "YouTube同步",
      emailAlerts: "邮件提醒",
      platformCredentials: "平台API凭证",
      credentialsDesc: "为每个社交媒体平台配置API凭证",
      addCredentials: "添加凭证",
      noCredentials: "尚未配置凭证",
      youtubeStatus: "YouTube API状态",
      youtubeConfigured: "YouTube API已配置",
      youtubeNotConfigured: "YouTube API未配置",
      syncChannel: "同步频道",
      refreshAll: "全部刷新",
      syncYoutubeChannel: "同步YouTube频道",
      syncDesc: "从YouTube频道导入视频和数据",
      channelHandle: "频道名称或URL",
      channelPlaceholder: "例如：@A2O_Channel 或 https://youtube.com/@A2O_Channel",
      syncing: "同步中...",
      emailStatus: "邮件服务状态",
      emailConfigured: "邮件服务已配置",
      emailNotConfigured: "邮件服务未配置",
      alertRules: "提醒规则",
      alertsDesc: "当指标低于或超过阈值时接收通知",
      createAlert: "创建提醒",
      noAlerts: "尚未配置提醒规则",
      alertName: "提醒名称",
      email: "邮箱",
      metric: "指标",
      condition: "条件",
      threshold: "阈值",
      below: "低于",
      above: "高于",
      lastTriggered: "最后触发",
      recentAlertHistory: "最近提醒记录",
      sent: "已发送",
      notSent: "未发送",
      cancel: "取消",
      save: "保存",
      delete: "删除",
    },
    export: {
      csv: "CSV",
      report: "报告",
    },
    languageAnalysis: {
      title: "评论语言分析",
      analyzeBtn: "分析语言",
      analyzing: "分析中...",
      totalComments: "已分析评论总数",
      language: "语言",
      count: "数量",
      percentage: "比例",
      sampleComments: "示例评论",
      noData: "暂无语言分析数据。点击分析按钮开始。",
      lastAnalyzed: "最后分析时间",
      commentsDisabled: "该视频已禁用评论",
    },
    comments: {
      title: "评论分析",
      summary: "摘要",
      postsAnalyzed: "已分析帖子",
      totalComments: "评论总数",
      languageDistribution: "语言分布",
      sentimentAnalysis: "情感分析",
      keywordsTopics: "关键词与话题",
      postsList: "帖子分析列表",
      batchAnalyze: "批量分析",
      analyzeAll: "全部分析",
      analyzing: "分析中...",
      positive: "积极",
      negative: "消极",
      neutral: "中立",
      sentiment: "情感",
      keyword: "关键词",
      noAnalysis: "暂无评论分析。选择帖子开始分析。",
      selectPosts: "选择要分析的帖子",
      filterByLanguage: "按语言筛选",
      filterBySentiment: "按情感筛选",
      allLanguages: "全部语言",
      allSentiments: "全部情感",
      viewDetails: "查看详情",
      overallSentiment: "总体情感",
      topKeywords: "热门关键词",
      analysisHistory: "分析历史",
      deleteAll: "全部删除",
      deleteAnalysis: "删除",
      confirmDeleteAll: "确定删除所有分析结果吗？",
      confirmDelete: "确定删除此分析结果吗？",
      historyCount: "条",
      noHistory: "无历史分析结果",
      loadHistory: "查看历史结果",
    },
    common: {
      language: "语言",
      english: "English",
      korean: "한국어",
      chinese: "中文",
    },
    // Content Growth
    contentGrowth: {
      title: "内容增长分析",
      subtitle: "追踪内容性能随时间的变化",
      selectPeriod: "选择时间段",
      startDate: "开始日期",
      endDate: "结束日期",
      analyze: "分析增长",
      analyzing: "分析中...",
      noData: "暂无增长数据。每日指标在中国时间00:00收集。",
      noDataDescription: "从今天开始收集数据。请等待至少2天的数据收集。",
      goodPerformers: "增长优秀内容",
      poorPerformers: "增长较弱内容",
      growthRate: "增长率",
      viewsDelta: "浏览量变化",
      likesDelta: "点赞变化",
      commentsDelta: "评论变化",
      sharesDelta: "分享变化",
      periodStart: "期间开始",
      periodEnd: "期间结束",
      delta: "变化量",
      allContent: "全部内容",
      sortBy: "排序",
      totalGrowth: "总增长",
      avgGrowthRate: "平均增长率",
      postsAnalyzed: "已分析帖子",
      manualSnapshot: "立即保存快照",
      snapshotSaved: "快照已保存",
      scheduleInfo: "数据每天中国时间00:00自动收集",
    },
  },
};

// Get post URL based on platform
export const getPostUrl = (platform, postId, username) => {
  switch (platform) {
    case "youtube":
      return `https://www.youtube.com/watch?v=${postId}`;
    case "tiktok":
      return `https://www.tiktok.com/@${username}/video/${postId}`;
    case "instagram":
      return `https://www.instagram.com/p/${postId}/`;
    case "weibo":
      return `https://weibo.com/${postId}`;
    case "xiaohongshu":
      return `https://www.xiaohongshu.com/explore/${postId}`;
    case "douyin":
      return `https://www.douyin.com/video/${postId}`;
    case "bilibili":
      return `https://www.bilibili.com/video/${postId}`;
    default:
      return null;
  }
};

export default translations;
